import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { RichText as PrismicRichText } from "prismic-reactjs"

import { Element, Text } from "legacy/components/shared/base"

import DownloadApp from "./DownloadApp"
import FooterNav from "./FooterNav"
import SocialNav from "./SocialNav"
import { useTheme } from "src/legacy/utils"

const Footer: React.FC = (): React.ReactElement => {
  const footerResponse = useStaticQuery(graphql`
    query MainFooter {
      allPrismicFooter {
        edges {
          node {
            data {
              footer_disclaimer {
                html
                richText
                text
              }
            }
          }
        }
      }
    }
  `)
  const { colors, sizes } = useTheme()

  const { t } = useTranslation("shared", {
    keyPrefix: "footer",
  })

  const disclaimer =
    footerResponse.allPrismicFooter?.edges[0]?.node?.data?.footer_disclaimer

  return (
    <Element as="footer" bg="navy">
      <Element
        display="grid"
        gridGap="0"
        gridTemplateAreas={[
          "'download' 'nav' 'social' 'copyright'",
          "'download download download' 'nav nav nav' 'social copyright copyright'",
          "'download download download' 'nav nav nav' 'social copyright copyright'",
          "'nav download download' 'nav social copyright'",
        ]}
        gridTemplateColumns={["1fr", "repeat(3, 1fr)", "60% repeat(2, 1fr)"]}
        gridTemplateRows={["auto"]}
        margin="0 auto"
        p="60px 40px"
        maxWidth={sizes.maxWidth}
        width="100%"
      >
        <FooterNav />
        <DownloadApp />
        <SocialNav />
        <Text
          alignItems="flex-end"
          as="p"
          color={colors.aqua}
          display="flex"
          fontSize={["12", "12", "text.copyright"]}
          gridArea="copyright"
          justifyContent={["center", "flex-end"]}
          mb={["55", "0"]}
          mt={["40", "60", "0"]}
          pr={["2px", "4px"]}
          top="-2px"
          variant="copyright"
        >
          {t("copyright", { year: new Date().getFullYear() })}
        </Text>
      </Element>
      {disclaimer?.richText && (
        <Text
          color="white"
          fontSize={["12", "12", "15"]}
          lineHeight={["18px", "27px"]}
          maxWidth="maxWidth"
          mx="auto"
          opacity="0.8"
          pb="60"
          px="40"
        >
          {PrismicRichText.asText(disclaimer.richText)}
        </Text>
      )}
    </Element>
  )
}

export default Footer
